import { render, staticRenderFns } from "./HistoryCard.vue?vue&type=template&id=0c91a191&scoped=true"
import script from "./HistoryCard.vue?vue&type=script&lang=js"
export * from "./HistoryCard.vue?vue&type=script&lang=js"
import style0 from "./HistoryCard.vue?vue&type=style&index=0&id=0c91a191&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c91a191",
  null
  
)

export default component.exports